import { mode } from '@chakra-ui/theme-tools';

export const globalStyles = {
  colors: {
    brand: {
      50: '#F3ECFF',
      100: '#E3D3FF',
      200: '#CCB0FF',
      300: '#AE86F2',
      400: '#8B5BDA',
      500: '#6F42C1',
      600: '#5F36AB',
      700: '#4D2A8B',
      800: '#3B206A',
      900: '#28154A',
    },
    brandScheme: {
      100: '#F3ECFF',
      200: '#CCB0FF',
      300: '#AE86F2',
      400: '#8B5BDA',
      500: '#6F42C1',
      600: '#5F36AB',
      700: '#4D2A8B',
      800: '#3B206A',
      900: '#28154A',
    },
    brandTabs: {
      100: '#F3ECFF',
      200: '#E3D3FF',
      300: '#CCB0FF',
      400: '#AE86F2',
      500: '#6F42C1',
      600: '#5F36AB',
      700: '#4D2A8B',
      800: '#3B206A',
      900: '#28154A',
    },
    secondaryGray: {
      100: '#E7ECF5',
      200: '#D8E0EE',
      300: '#F6F8FC',
      400: '#EDF1F8',
      500: '#A5B1C8',
      600: '#7C8BA8',
      700: '#62738F',
      800: '#41516D',
      900: '#202B3F',
    },
    red: {
      100: '#FFF1EF',
      500: '#E56A54',
      600: '#D44833',
    },
    blue: {
      50: '#EAF8FF',
      500: '#007BFF',
    },
    orange: {
      100: '#FFF4DB',
      500: '#F3AF45',
    },
    green: {
      100: '#E8FBFB',
      500: '#00CCCC',
      600: '#17A2B8',
    },
    cyan: {
      100: '#E5FBFD',
      300: '#79E5F6',
      500: '#0DCAF0',
      700: '#17A2B8',
    },
    navy: {
      50: '#DCE5FF',
      100: '#B8C7F4',
      200: '#99ABDA',
      300: '#7788BC',
      400: '#5A6B9F',
      500: '#394A7A',
      600: '#2D3D63',
      700: '#232F4B',
      800: '#172133',
      900: '#0E1625',
    },
    gray: {
      100: '#FBFCFE',
    },
  },
  styles: {
    global: (props) => ({
      body: {
        overflowX: 'hidden',
        bg: mode('var(--app-bg-light)', 'var(--app-bg-dark)')(props),
        color: mode('secondaryGray.900', 'whiteAlpha.900')(props),
        fontFamily: "'Urbanist', sans-serif",
        letterSpacing: '-0.01em',
      },
      html: {
        fontFamily: "'Urbanist', sans-serif",
      },
      a: {
        color: 'inherit',
      },
      '::selection': {
        bg: mode('brand.100', 'brand.500')(props),
      },
      h1: {
        fontFamily: "'Fraunces', serif",
        fontWeight: '700',
        letterSpacing: '-0.04em',
      },
      h2: {
        fontFamily: "'Fraunces', serif",
        fontWeight: '700',
        letterSpacing: '-0.04em',
      },
      h3: {
        fontWeight: '800',
      },
    }),
  },
};
